// extracted by mini-css-extract-plugin
export default {"body":"Wrapper_body__Zd-kU"};